import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classPrivateFieldLooseBase from "@babel/runtime/helpers/esm/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/esm/classPrivateFieldLooseKey";
var _configuration = /*#__PURE__*/_classPrivateFieldLooseKey("configuration");
var _mightWantToSendAgain = /*#__PURE__*/_classPrivateFieldLooseKey("mightWantToSendAgain");
var _pendingSend = /*#__PURE__*/_classPrivateFieldLooseKey("pendingSend");
var _sendInterval = /*#__PURE__*/_classPrivateFieldLooseKey("sendInterval");
var _startInterval = /*#__PURE__*/_classPrivateFieldLooseKey("startInterval");
var _clearInterval = /*#__PURE__*/_classPrivateFieldLooseKey("clearInterval");
var _getLogsFromStorage = /*#__PURE__*/_classPrivateFieldLooseKey("getLogsFromStorage");
var _send = /*#__PURE__*/_classPrivateFieldLooseKey("send");
export default class BatchStrategy {
  constructor(sender, storage, configuration) {
    Object.defineProperty(this, _send, {
      value: _send2
    });
    Object.defineProperty(this, _getLogsFromStorage, {
      value: _getLogsFromStorage2
    });
    Object.defineProperty(this, _clearInterval, {
      value: _clearInterval2
    });
    Object.defineProperty(this, _startInterval, {
      value: _startInterval2
    });
    this.sender = void 0;
    this.storage = void 0;
    this.handledLogTypes = void 0;
    this.ignoredLogTypes = void 0;
    Object.defineProperty(this, _configuration, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _mightWantToSendAgain, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _pendingSend, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _sendInterval, {
      writable: true,
      value: void 0
    });
    this.sender = sender;
    this.storage = storage;
    _classPrivateFieldLooseBase(this, _configuration)[_configuration] = configuration;
    this.handledLogTypes = configuration.handledLogTypes || null;
    this.ignoredLogTypes = configuration.ignoredLogTypes || null;
    _classPrivateFieldLooseBase(this, _startInterval)[_startInterval]();
  }
  destruct() {
    _classPrivateFieldLooseBase(this, _clearInterval)[_clearInterval]();
  }
  notify() {
    var _this = this;
    return _asyncToGenerator(function* () {
      const logsToBeSent = yield _classPrivateFieldLooseBase(_this, _getLogsFromStorage)[_getLogsFromStorage]();

      // Send the batch if we reached the `maxBatchSize`
      if (logsToBeSent.length >= _classPrivateFieldLooseBase(_this, _configuration)[_configuration].maxBatchSize) {
        _classPrivateFieldLooseBase(_this, _send)[_send]();
        _classPrivateFieldLooseBase(_this, _mightWantToSendAgain)[_mightWantToSendAgain] = true;
      }
    })();
  }
  acknowledge(handledLogKeys) {
    handledLogKeys.forEach(logKey => {
      this.storage.delete(logKey);
    });
    _classPrivateFieldLooseBase(this, _pendingSend)[_pendingSend] = false;

    // Start the timer again to ensure timing predictability
    _classPrivateFieldLooseBase(this, _startInterval)[_startInterval]();
    if (_classPrivateFieldLooseBase(this, _mightWantToSendAgain)[_mightWantToSendAgain]) {
      // Do not notify before reseting `mightWantToSendAgain`, notify might want to send again
      _classPrivateFieldLooseBase(this, _mightWantToSendAgain)[_mightWantToSendAgain] = false;

      // Avoid looping if no log is acknowledged despite exceeding the maxBatchSize
      if (handledLogKeys.length > 0) {
        this.notify();
      }
    }
  }
  flush() {
    _classPrivateFieldLooseBase(this, _send)[_send]();
  }
}
function _startInterval2() {
  _classPrivateFieldLooseBase(this, _sendInterval)[_sendInterval] = setInterval(_classPrivateFieldLooseBase(this, _send)[_send].bind(this), _classPrivateFieldLooseBase(this, _configuration)[_configuration].autoSendInterval);
}
function _clearInterval2() {
  if (_classPrivateFieldLooseBase(this, _sendInterval)[_sendInterval]) {
    clearInterval(_classPrivateFieldLooseBase(this, _sendInterval)[_sendInterval]);
  }
}
function _getLogsFromStorage2() {
  return _getLogsFromStorage3.apply(this, arguments);
}
function _getLogsFromStorage3() {
  _getLogsFromStorage3 = _asyncToGenerator(function* () {
    return this.ignoredLogTypes ? this.storage.getLogsNotOfType(_classPrivateFieldLooseBase(this, _configuration)[_configuration].maxBatchSize, this.ignoredLogTypes) : this.storage.getLogsOfType(_classPrivateFieldLooseBase(this, _configuration)[_configuration].maxBatchSize, this.handledLogTypes);
  });
  return _getLogsFromStorage3.apply(this, arguments);
}
function _send2() {
  return _send3.apply(this, arguments);
}
function _send3() {
  _send3 = _asyncToGenerator(function* () {
    if (_classPrivateFieldLooseBase(this, _pendingSend)[_pendingSend]) {
      return;
    }
    // Setting `pendingSend` to true before any async work to avoid
    // multiple parallels calls to send the same logs
    _classPrivateFieldLooseBase(this, _pendingSend)[_pendingSend] = true;
    const logsToBeSent = yield _classPrivateFieldLooseBase(this, _getLogsFromStorage)[_getLogsFromStorage]();
    if (logsToBeSent.length < _classPrivateFieldLooseBase(this, _configuration)[_configuration].minBatchSize) {
      _classPrivateFieldLooseBase(this, _pendingSend)[_pendingSend] = false;
      return;
    }

    // Clear the timer to ensure timing predictability
    _classPrivateFieldLooseBase(this, _clearInterval)[_clearInterval]();
    yield this.sender.send(logsToBeSent, this.acknowledge.bind(this));
  });
  return _send3.apply(this, arguments);
}
//# sourceMappingURL=index.js.map